import * as Sentry from "@sentry/angular";
/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { SENTRY_CLIENT_CONFIG } from './sentry.client.config';

if (environment.sentryEnabled && environment.sentryDsn) {
  Sentry.init({
      dsn: environment.sentryDsn,
      environment: environment.sentryEnvironment,
      integrations: SENTRY_CLIENT_CONFIG.integrations, // Re-enable advanced integrations
      tracesSampleRate: SENTRY_CLIENT_CONFIG.tracesSampleRate,
      replaysSessionSampleRate: SENTRY_CLIENT_CONFIG.replaysSessionSampleRate,
      replaysOnErrorSampleRate: SENTRY_CLIENT_CONFIG.replaysOnErrorSampleRate,
      enableLogs: true
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
